import { Checkbox, FormControlLabel, Grid2, Paper, TextField } from "@mui/material";
import { actions } from "components/settings/tags/logic/actions";
import log from "loglevel";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import "./styles.scss";
const TagSearch = ({ getReviewTags }) => {
    const [disabled, setDisabled] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const onChage = (e) => {
        log.debug(e.target.value);
        getReviewTags({
            tagName: e.target.value,
            isDeleted: disabled ? "ALL" : "NOT_DELETED",
        });
        setSearchValue(e.target.value);
    };

    const onCheckboxChange = (e) => {
        setDisabled(e.target.checked);
        getReviewTags({
            tagName: searchValue,
            isDeleted: e.target.checked ? "ALL" : "NOT_DELETED",
        });
    };

    return (
        (<Grid2 className="tag-search" size={12}>
            <Paper style={{ padding: 16 }}>
                <Grid2 size={12}>
                    <TextField label="Search" margin="normal" variant="outlined" name="search" onChange={onChage} />
                </Grid2>
                <Grid2 size={12}>
                    <FormControlLabel
                        control={<Checkbox checked={disabled} onChange={onCheckboxChange} />}
                        label="Show disabled"
                    />
                </Grid2>
            </Paper>
        </Grid2>)
    );
};

TagSearch.propTypes = {
    getReviewTags: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    getReviewTags: (query) => dispatch(actions.GET_REVIEW_TAGS.send(query)),
});

export default connect(null, mapDispatchToProps)(TagSearch);
